import React, { useEffect, useRef } from 'react';
import { Typography } from 'shared/ui/typography';
import { GridContainer, HiddenContainer } from '../styles';
import { TableHeaderProps } from '../types';

export const TableHeader: React.FC<TableHeaderProps> = ({
	headers = [],
	gridSettings = {
		moreSpaceForLastColumn: true,
		columnSize: 1,
		trackSize: 3,
	},
	specificColumnSizes,
	isFixedHeader,
}) => {
	const ref = useRef();

	const observer = new IntersectionObserver(
		([e]) =>
			e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
		{ threshold: [1] },
	);

	useEffect(() => {
		if (ref.current && isFixedHeader) {
			observer.observe(ref.current);
		}
		//eslint-disable-next-line
	}, [ref.current]);

	useEffect(() => {
		return () => observer.disconnect();
		//eslint-disable-next-line
	}, []);

	return (
		<>
			{headers && headers.length && (
				<>
					{isFixedHeader && <HiddenContainer />}
					<GridContainer
						$columns={
							gridSettings.moreSpaceForLastColumn
								? headers.length - 1
								: headers.length
						}
						$columnSize={gridSettings.columnSize}
						$trackSize={gridSettings.trackSize}
						$specificColumnSizes={specificColumnSizes}
						$isFixedHeader={isFixedHeader}
						ref={ref as any}
					>
						{headers.map((header, index) => (
							<div key={index}>
								<Typography mode={'small'}>{header}</Typography>
							</div>
						))}
					</GridContainer>
				</>
			)}
		</>
	);
};
